import "./TestCreateScreen.scss";
import {ITimelineItem} from "../../../shared/models/timeline.model";
import React, {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import {useNavigate, useSearchParams} from "react-router-dom";
import {CommonService} from "../../../shared/services";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {ImageConfig} from "../../../constants";
import Grid from "@mui/material/Grid";
import TimelineComponent from "../../../shared/components/timeline/timelineComponent";
import TestDetailsAddComponent from "./test-details-add/TestDetailsAddComponent";
import TestAttachmentsComponent from "./test-attachments/testAttachmentsComponent";
import {useDispatch} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";
import TestConfigurationAddComponent from "./test-configuration-add/TestConfigurationAddComponent";
import AssignLabToTestComponent from "./assign-lab-to-test/AssignLabToTestComponent";
import TestReportComponent from "../test-report/TestReportComponent";
import TestIcdCodesComponent from "./test-icd-codes/TestIcdCodesComponent";
import TestCptCodesComponent from "./test-cpt-codes/TestCptCodesComponent";

interface TestPanelCreateComponentProps {

}

const BASIC_DETAILS = 'basic_details';
const ATTACHMENTS = 'attachments';
const CONFIGURATION = 'configuration';
const ASSIGN_LAB = 'assign_lab';
const REPORT_TYPE = 'report_type';
const ICD_CODE = 'icd_code';
const CPT_CODE = 'cpt_code';

const STEPS: ITimelineItem[] = [
    {
        id: BASIC_DETAILS,
        title: "Basic Details",
    },
    {
        id: REPORT_TYPE,
        title: "Report Type"
    },
    {
        id: ICD_CODE,
        title: "ICD Code"
    },
    {
        id: CPT_CODE,
        title: "CPT Code"
    },
    {
        id: CONFIGURATION,
        title: "Configuration",
    },
    {
        id: ASSIGN_LAB,
        title: "Assign Lab",
    },
    {
        id: ATTACHMENTS,
        title: "Attachments",
    }
];


const TestCreateScreen = (props: TestPanelCreateComponentProps) => {

    const [steps] = useState<ITimelineItem[]>([..._.cloneDeep(STEPS)]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [currentStep, setCurrentStep] = useState<ITimelineItem | undefined>(STEPS[0]);
    const [testID, setTestID] = useState<number | undefined>(undefined);
    const [activeStep, setActiveStep] = React.useState(0);
    const [testDetails, setTestDetails] = useState<any>(undefined);
    const [isTestPanelDetailsLoading, setIsTestDetailsLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setCurrentNavParams("", "Test"));
        dispatch(setSideMenuView('compact'));
    }, [dispatch]);

    const updateSteps = useCallback((currentStepIndex: number) => {
        setCurrentStep(STEPS[currentStepIndex]);
        searchParams.set("step", STEPS[currentStepIndex].id);
        setSearchParams(searchParams);
        setActiveStep(currentStepIndex);
    }, [searchParams, setSearchParams]);

    const getTestDetails = useCallback(() => {
        setIsTestDetailsLoading(true);
        CommonService._test.getTestDetails(testID)
            .then((response: IAPIResponseType<any>) => {
                setTestDetails(response?.data);
                setIsTestDetailsLoading(false);
            })
            .catch((error: any) => {
                setIsTestDetailsLoading(false);
            });
    }, [testID]);

    const handleTestCancel = useCallback(() => {
        CommonService.openConfirmationDialog({
            confirmationTitle: 'Please confirm!',
            confirmationSubTitle: 'Are you sure you want to exit without adding this test?',
            disableEscKeyClose: false,
            disableBackdropClose: true,
            imagePath: `${ImageConfig.ConfirmationImage}`,
            direction: "up",
            yes: {
                text: "Exit",
                color: "primary"
            },
            no: {
                text: "Cancel",
                color: "primary"
            }
        }).then(() => {
            navigate(CommonService._routeConfig.TestListRoute());
        }).catch(() => {
            // do nothing;
        });
    }, [navigate]);

    const handleADDSuccess = useCallback(() => {
        CommonService.openConfirmationDialog({
            confirmationTitle: 'Congratulations! ',
            confirmationSubTitle: 'Test has been successfully created.',
            disableEscKeyClose: false,
            disableBackdropClose: true,
            imagePath: `${ImageConfig.CongratulationImage}`,
            direction: "up",
            hideNoOption: true,
            yes: {
                text: "Proceed",
                color: "primary"
            }

        }).then(() => {
            navigate(CommonService._routeConfig.TestListRoute());
        })
            .catch(() => {
            });
    }, [navigate]);


    const handleNext = useCallback((currentStepIndex: number, currentStepId: string, testId?: number, data?: any) => {
        switch (currentStepId) {
            case BASIC_DETAILS :
                if (testId) {
                    setTestID(testId);
                    searchParams.set("testId", testId.toString());
                    setSearchParams(searchParams);
                }
                if (data) {
                    setTestDetails(data);
                }
                updateSteps(currentStepIndex);
                break;
            case CONFIGURATION:
                if (data) {
                    setTestDetails(data);
                }
                updateSteps(currentStepIndex);
                break;
            case ASSIGN_LAB:
                updateSteps(currentStepIndex);
                break;
            case ATTACHMENTS:
                handleADDSuccess();
                // updateSteps(currentStepIndex);
                break;
            default:
                <></>
        }
    }, [searchParams, setSearchParams, updateSteps, handleADDSuccess]);

    useEffect(() => {
        const step = searchParams.get("step");
        setActiveStep(STEPS.findIndex((stepItem: any) => stepItem.id === step));
        const testId = searchParams.get("testId");
        const stepIDS = STEPS.map(item => item.id);
        let stepIndex = 0;
        if (testId) {
            setTestID(parseInt(testId, 10));
            if (stepIDS.indexOf(step) > -1) {
                stepIndex = stepIDS.indexOf(step);
            } else {
                stepIndex = 1;
            }
        } else {
            stepIndex = 0;
            setActiveStep(0)
        }
        setCurrentStep(STEPS[stepIndex]);
    }, [searchParams]);

    const handlePrevious = useCallback((currentStepIndex: number, currentStepId: string) => {
        if ([CONFIGURATION, ATTACHMENTS, ASSIGN_LAB, REPORT_TYPE, ICD_CODE,CPT_CODE].includes(currentStepId)) {
            updateSteps(currentStepIndex);
        } else {
            // do nothing;
        }
    }, [updateSteps]);

    const renderComponent = useCallback(() => {
        if (!testID) {
            if (currentStep?.id === BASIC_DETAILS) {
                return <TestDetailsAddComponent
                    testID={testID}
                    testDetails={testDetails}
                    next={(testId: number, data: any) => handleNext(1, BASIC_DETAILS, testId, data)}
                    cancel={handleTestCancel}
                />
            }
        } else {
            switch (currentStep && currentStep.id) {
                case BASIC_DETAILS:
                    return <TestDetailsAddComponent
                        testID={testID}
                        cancel={handleTestCancel}
                        testDetails={testDetails}
                        next={(testId: number, data: any) => handleNext(1, BASIC_DETAILS, testId, data)}
                    />
                case REPORT_TYPE:
                    return <TestReportComponent
                        testID={testID}
                        testDetails={testDetails}
                        cancel={handleTestCancel}
                        next={(data: any) => handleNext(2, CONFIGURATION, undefined, data)}
                        prev={() => handlePrevious(0, CONFIGURATION)}
                    />
                case ICD_CODE:
                    return <TestIcdCodesComponent
                        testID={testID}
                        testDetails={testDetails}
                        cancel={handleTestCancel}
                        next={(data: any) => handleNext(3, CONFIGURATION, undefined, data)}
                        prev={() => handlePrevious(1, CONFIGURATION)}
                    />
                case CPT_CODE:
                    return <TestCptCodesComponent
                        testID={testID}
                        testDetails={testDetails}
                        cancel={handleTestCancel}
                        next={(data: any) => handleNext(4, CONFIGURATION, undefined, data)}
                        prev={() => handlePrevious(2, CONFIGURATION)}
                    />
                case CONFIGURATION:
                    return <TestConfigurationAddComponent
                        testID={testID}
                        testDetails={testDetails}
                        cancel={handleTestCancel}
                        next={(data: any) => handleNext(5, CONFIGURATION, undefined, data)}
                        prev={() => handlePrevious(3, CONFIGURATION)}
                    />
                case ASSIGN_LAB:
                    return <AssignLabToTestComponent
                        testID={testID}
                        cancel={handleTestCancel}
                        next={() => handleNext(6, ASSIGN_LAB, undefined, undefined)}
                        prev={() => handlePrevious(4, ASSIGN_LAB)}
                    />
                case ATTACHMENTS:
                    return <TestAttachmentsComponent
                        testID={testID}
                        cancel={handleTestCancel}
                        next={(data: any) => handleNext(7, ATTACHMENTS, undefined, data)}
                        prev={() => handlePrevious(5, ATTACHMENTS)}
                    />
                default:
                    <></>
            }
        }
    }, [testID, currentStep, handleNext, handleTestCancel, handlePrevious, testDetails]);

    useEffect(() => {
        if (testID) {
            getTestDetails();
        }
    }, [testID, getTestDetails]);

    return (
        <div className="test-order-creation-layout-screen add-layout-with-timeline screen ">
            <Grid container spacing={2} className="add-form-timeline-wrapper">
                <Grid item sm={12} md={3} xl={3} className="timeline-layout"
                      sx={{
                          display: {xs: "none", md: "block"}
                      }}>
                    <div className="add-layout-title">Adding Test</div>
                    <div className="add-layout-timeline">
                        <TimelineComponent
                            activeStep={activeStep}
                            steps={steps}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={9} xl={9} className="add-form-content">
                    <div className="add-layout-form-content">
                        {renderComponent()}
                    </div>
                </Grid>
            </Grid>
            {isTestPanelDetailsLoading &&
                <div className={"glass-effect h-v-center flex-direction-column"}>
                    <LottieFileGenarationComponent
                        loop={true}
                        autoplay={true}
                        animationData={ImageConfig.LoadingLottieFile}/>
                </div>
            }
        </div>
    )

};

export default TestCreateScreen;
